/**
 * todo: Make use of this file
 * Constants for the online booking, these values are stored in the vuex store.
 * @type {{ PRODUCTS: string, EVENT_INFO: string, FILL_INFORMATION: string, GIFT_CARD: string, CALENDAR: string, TIME: string, VOUCHER: string, ADDON_PRODUCTS: string, COURSE_INFO: string }}
 */

export const bookingKeys = Object.freeze({
	CALENDAR: 'calendar',
	PRODUCTS: 'products',
	ADDON_PRODUCTS: 'addonProducts',
	TIME: 'time',
	GIFT_CARD: 'giftCard',
	VOUCHER: 'voucher',
	EVENT_INFO: 'eventInfo',
	COURSE_INFO: 'courseInfo',
	FILL_INFORMATION: 'fillInformation',
	SUBSCRIPTION_INFO: 'subscriptionInfo',
})

/*
 * immediately invoked function expression
 * returns an object with the keys as the values of the bookingKeys object and the values as empty strings
 */

export const bookingValues = (() => {
	const bookingValues = {};
	Object.keys(bookingKeys).forEach((key) => {
		bookingValues[bookingKeys[key]] = '';
	});
	return bookingValues;
})();

// BookAppointment, BookGiftCard, Voucher, BookEvent, BookCourse
export const bookingModules = Object.freeze({
	BOOK_APPOINTMENT: 'BookAppointment',
	BOOK_GIFT_CARD: 'BookGiftCard',
	BOOK_VOUCHER: 'BookVoucher',
	BOOK_EVENT: 'BookEvent',
	BOOK_COURSE: 'BookCourse',
	BOOK_SUBSCRIPTION: 'BookSubscription',
});
